import TrailerUpload from "./trailer";

const SeriesUploader = ({ selectedContent, updateContent }) => {

    const formattedTrailer = {
        ...selectedContent,
        contentId: selectedContent.key,
        contentType: "series_trailer",
    }

    const handleContentUpdate = (content) => {
        updateContent(content)
    }

    return (
        <div>
            <TrailerUpload selectedContent={formattedTrailer} updateTrailer={handleContentUpdate} />
        </div>
    )
}

export default SeriesUploader;
